if (!customElements.get('unasuave-bundle-media')) {
  class UnasuaveBundleMedia extends HTMLElement {
    connectedCallback() {
      this.productRoot = document.getElementById(this.dataset.sectionId);
      if (!this.productRoot) return;
      this.media = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.onChange = (event) => {
        if (!event.target.closest('quantity-breaks')) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.productRoot.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      this.productRoot?.removeEventListener('change', this.onChange);
      cancelAnimationFrame(this.frame);
    }

    sync() {
      this.productRoot.querySelectorAll('quantity-breaks .quantity-break').forEach((card) => {
        const rows = [...card.querySelectorAll('.quantity-break__selector-item')];
        const selectedImages = rows.map((row, index) => {
          const selects = [...row.querySelectorAll('select')];
          const color = selects[0];
          if (!color) return null;
          const label = card.querySelector('.quantity-break__variants__label')?.textContent.trim();
          if (label) color.setAttribute('aria-label', label + ' #' + (index + 1));
          const source = this.media.images[color.value];
          return source ? {
            src: source,
            alt: this.media.productTitle + ' · ' + color.value
          } : null;
        }).filter(Boolean);
        const container = card.querySelector('.quantity-break__image');
        if (!container || !selectedImages.length) return;
        container.classList.add('pm-unasuave-bundle-images');
        while (container.children.length > selectedImages.length) container.lastElementChild.remove();
        selectedImages.forEach((selected, index) => {
          let img = container.children[index];
          if (!img || img.tagName !== 'IMG') {
            img = document.createElement('img');
            container.append(img);
          }
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          if (img.getAttribute('src') !== selected.src) img.src = selected.src;
          img.alt = selected.alt;
          img.width = 320;
          img.height = 320;
          img.loading = 'eager';
          img.decoding = 'async';
        });
      });
    }
  }
  customElements.define('unasuave-bundle-media', UnasuaveBundleMedia);
}


